export default {
  isId (value) {
    if (undefined === value || isNaN(value) || value <= 0 || value === false) {
      return false
    }
    return true
  },
  isEmpty (value) {
    if (undefined === value || value === '' || value === null || value === 'null' || value === false || value === 'false' || value === 'undefined') {
      return true
    }
    return false
  },
  isValid(value, type) {
    switch(type) {
      case Core.Value.typeBookingSummary:
        if (Array.isArray(value)) {
          for(let booking in value) {
            booking = value[booking]
            if (booking.user !== undefined) {
              if (!Core.Validation.isId(booking.user.id) && booking.user.email === '') {
                return false
              }
            }
          }
        } else {
          return false
        }
        break
      default:
      break
    }
    return true
  },
  isJSON(str) {
    try {
      return (JSON.parse(str) && !!str);
    } catch (e) {
      return false;
    }
  }
}
